import React, { Component } from 'react';
import { Flex, Box } from 'grid-styled';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { ThemeProvider } from 'styled-components';
import connect from '../store/connect';
import { fetchArticlePageView } from '../actions/actionCreators';
import Page from './Page';
import { Heading } from '../styles/Heading';
import { color, size } from '../styles/helpers/variables';
import { Container } from '../styles/Container';
import { NavigationButton } from '../components/NavigationButton';
import { Preamble } from '../styles/Preamble';
import { FullWidthContainer } from '../styles/FullWidthContainer';
import { HeroImage } from '../components/HeroImage';
import { SITE_ROOT_URL } from '../constants/endpoints';

class CategoryLink extends Component {
  componentDidMount() {
    this.props.fetchArticlePageView({ urlPath: this.props.location.pathname });
  }

  render() {
    const { currentPage } = this.props;
    const childRoutes = this.props.item.get('children');
    const subcategoryButtons = childRoutes
      .map(item => (
        <Box
          key={item.get('id')}
          width={[1, 1, 1 / 2, 1 / 2, 1 / 3]}
          py={['5px', '8px', '11px']}
          px={['0px', '8px', '11px']}
        >
          <NavigationButton url={item.get('url')} image={item.get('image')} title={item.get('title')} />
        </Box>
      ))
      .toArray();

    return (
      <Page meta={this.props.currentPage.get('metaData')} bgColor={currentPage.getIn(['fields', 'color'], color.lightgrey)}>
        <FullWidthContainer bgColor={currentPage.getIn(['fields', 'color'], color.lightgrey)}>
          <Container>
            <Heading big center>
              {currentPage.getIn(['fields', 'title'])}
            </Heading>
            <Preamble>{currentPage.getIn(['fields', 'description'])}</Preamble>
            <ThemeProvider
              theme={{
                breakpoints: ['500px', '800px', `${size.large}px`, '1100px']
              }}
            >
              <Flex flexWrap="wrap" mx={['0px', '-8px', '-11px']} mt={60} mb={20}>
                {subcategoryButtons}
              </Flex>
            </ThemeProvider>
          </Container>
          <HeroImage bgColor={color.lightGrey} url={SITE_ROOT_URL + currentPage.getIn(['fields', 'image', 'url'])} />
        </FullWidthContainer>

        <FullWidthContainer bgColor={color.lightGrey}>
          <Container />
        </FullWidthContainer>
      </Page>
    );
  }
}

CategoryLink.defaultProps = {
  item: Map(),
  currentPage: Map(),
};

CategoryLink.propTypes = {
  item: PropTypes.instanceOf(Map),
  currentPage: PropTypes.instanceOf(Map),
  fetchArticlePageView: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

export default connect(
  CategoryLink,
  { fetchArticlePageView },
  (store, props) => ({
    currentPage: store.page.data.get(props.location.pathname, Map()),
  })
);



// WEBPACK FOOTER //
// ./src/pages/CategoryLink.js